// Sarrdeh: "Leads" page (conversations scored by the n8n lead-scoring AI). Administrators only.
import { frontendURL } from '../../../helper/URLHelper';
import LeadsPage from './LeadsPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/leads'),
    name: 'leads_index',
    component: LeadsPage,
    meta: {
      permissions: ['administrator'],
    },
  },
];
